import { useAppStore } from '~/stores/appStore/appStore';

/**
 * Keeps Algolia search userToken and Insights click userToken in sync after
 * Cookiebot statistics consent (DBP-4233).
 */
function syncAlgoliaUserToken(): void {
  useAppStore().syncAlgoliaUserTokenAfterConsent();
}

export default defineNuxtPlugin((nuxtApp) => {
  window.addEventListener('CookiebotOnConsentReady', syncAlgoliaUserToken);
  window.addEventListener('CookiebotOnAccept', syncAlgoliaUserToken);

  nuxtApp.hook('app:mounted', () => {
    syncAlgoliaUserToken();
  });
});
